export const DEPOSIT_FIELDS_ERRORS = {
    amount: ['error.minimum_deposit', 'error.next_deposit'],
}
